export type EndDateInput = Date | string | null | undefined;

export function toValidDate(input: EndDateInput): Date | null {
  if (!input) return null;

  const asDate = input instanceof Date ? input : new Date(input);
  return Number.isNaN(asDate.getTime()) ? null : asDate;
}

export function getEndsInDisplay(
  endDate: Date,
  now: Date = new Date()
): {
  formattedTime: string;
  isError: boolean;
  isPast: boolean;
} {
  const diffMs = endDate.getTime() - now.getTime();

  if (diffMs <= 0) {
    return { formattedTime: "0d 0h 0m", isError: false, isPast: true };
  }

  const diffHours = diffMs / (1000 * 60 * 60);
  const isError = diffHours < 24;

  const MINUTE_MS = 60_000;
  const HOUR_MS = 60 * MINUTE_MS;
  const DAY_MS = 24 * HOUR_MS;
  const WEEK_MS = 7 * DAY_MS;
  const MONTH_MS = 30 * DAY_MS;
  const YEAR_MS = 365 * DAY_MS;

  let remainingMs = diffMs;

  const years = Math.floor(remainingMs / YEAR_MS);
  remainingMs %= YEAR_MS;
  const months = Math.floor(remainingMs / MONTH_MS);
  remainingMs %= MONTH_MS;
  const weeks = Math.floor(remainingMs / WEEK_MS);
  remainingMs %= WEEK_MS;
  const days = Math.floor(remainingMs / DAY_MS);
  remainingMs %= DAY_MS;
  const hours = Math.floor(remainingMs / HOUR_MS);
  remainingMs %= HOUR_MS;
  const minutes = Math.floor(remainingMs / MINUTE_MS);

  let formattedTime: string;
  if (years > 0) {
    formattedTime = `${formatTimeString("years", years)}${formatTimeString("months", months)}${formatTimeString("weeks", weeks)}`;
  } else if (months > 0) {
    formattedTime = `${formatTimeString("months", months)}${formatTimeString("weeks", weeks)}${formatTimeString("days", days)}`;
  } else if (weeks > 0) {
    formattedTime = `${formatTimeString("weeks", weeks)}${formatTimeString("days", days)}${formatTimeString("hours", hours)}`;
  } else {
    formattedTime = `${formatTimeString("days", days)}${formatTimeString("hours", hours)}${formatTimeString("minutes", minutes)}`;
  }

  return { formattedTime, isError, isPast: false };
}

export function toFormatDateInput(date: Date): string {
  return date.toISOString();
}

export const getDaysRemaining = (dateString: EndDateInput) => {
  const end = toValidDate(dateString);
  if (!end) return 0;

  const now = new Date();

  const diffMs = end.getTime() - now.getTime();

  if (diffMs <= 0) return 0;

  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
};

const formatTimeString = (
  period: "years" | "months" | "weeks" | "days" | "hours" | "minutes",
  value: number
) => {
  if (value) {
    switch (period) {
      case "years":
        return `${value}y `;
      case "months":
        return `${value}mo `;
      case "weeks":
        return `${value}w `;
      case "days":
        return `${value}d `;
      case "hours":
        return `${value}h `;
      case "minutes":
        return `${value}m `;
      default:
        return "";
    }
  }

  return "";
};
